import React, { useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import { Logo } from '../../Assets';
import { Button } from '../../Atoms';
import { validateInvite } from '../../redux/actions/ManagerAction';
import useToaster from '../../components/Toaster/useToaster';
import { getQueryStringValue } from '../../utils/helper';
import WelcomeVideo from './welcome.mp4';

import './welcome.scss';
import { Loader } from '../../components';

const Welcome = ({
  validateInvite,
  validate: { loading, success, error },
  userInfo: { info },
  userInfoManager: { company: { intro_video: introVideo } = {} },
}) => {
  const history = useHistory();
  const { toast } = useToaster();
  const token = getQueryStringValue('token');
  const { intro_video } = info?.company || {};
  const ref = useRef(null);
  useEffect(() => {
    if (token) {
      validateInvite({ token });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleContinue = () => {
    if (success || info) {
      history.push('/info');
    }

    if (error) {
      toast({
        text: error,
        type: 'error',
      });
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="wrapper custom-wrapper">
      <div className="info-wrapper">
        <div className="welcome-section">
          <Logo width={173} height={34} />
          <h2>Welcome</h2>
          <p>
            {' '}
            Thank you for taking time to join us on this platform.  We decided
            to share Peak Mind with you all because we care about your
            well-being.  As CEO, I truly have a passion for healthy work
            environments, and want ours to be one: Today and every day.  Using
            technology will help us duplicate the great efforts of our HR and
            Culture staff.
          </p>

          <Button
            size="lg"
            color="blue"
            disabled={loading}
            onClick={handleContinue}
          >
            Continue
          </Button>
        </div>
        <div className="video-wrapper d-flex justify-content-center">
          <video
            autoPlay
            height="100%"
            controls="controls"
            src={intro_video || introVideo || WelcomeVideo}
            ref={ref}
          >
            <source
              src={intro_video || introVideo || WelcomeVideo}
              type="video/mp4"
            />
          </video>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  validate: state.manager.validate,
  userInfoManager: state.manager.userInfo || {},
  userInfo: state.auth.userInfo,
});

const mapDispatchToProps = (dispatch) => ({
  validateInvite: (details) => {
    dispatch(validateInvite(details));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
